import React, { useState } from "react";
import "./products-section.css";
import { FlareCollectionView, type TFlareCollectionViewMode } from "flare-ui";
import { ProductCard } from "@/components/app-components/product-card";
import type { Category } from "@/data/categories";
import type { Product } from "@/data/products";
import type { LocaleCode } from "@/i18n/locales";
import type { InterpolationValues } from "@/i18n/types";

interface Props {
    products: Product[];
    categories: Category[];
    locale: LocaleCode;
    quantities: Record<string, number>;
    t: (key: string, values?: InterpolationValues) => string;
    onQuantityChange: (id: string, quantity: number) => void;
    onAdd: (id: string) => void;
}

export function ProductsSection(props: Props) {
    const countLabel = props.t("home.products.count", { count: props.products.length });
    const [viewMode, setViewMode] = useState<TFlareCollectionViewMode>("grid");
    const viewLabels = {
        grid: props.t("home.products.grid"),
        list: props.t("home.products.list"),
        compact: props.t("home.products.compact"),
        viewOptions: props.t("home.products.viewOptions")
    };

    return (
        <section className="section" id="products">
            <div className="section-head"><div><span className="section-kicker">{props.t("home.products.kicker")}</span><h2>{props.t("home.products.title")}</h2><p>{props.t("home.products.description")}</p></div></div>
            <FlareCollectionView
                viewMode={viewMode}
                onViewModeChange={setViewMode}
                labels={viewLabels}
                toolbarStart={<div className="catalog-meta"><strong>{countLabel}</strong></div>}
                contentClassName={`product-grid product-grid--${viewMode}`}
                gridMinItemWidth="16rem"
                gridMaxItemWidth="20rem"
                compactMinItemWidth="13rem"
                compactMaxItemWidth="16rem"
                mobileGridMinItemWidth="10.75rem"
            >
                {props.products.map(product => {
                    const category = props.categories.find(item => item.id === product.categoryId);
                    const categoryLabel = category ? (category.name ?? (category.translationKey ? props.t(category.translationKey) : props.t("commerce.product.category"))) : props.t("commerce.product.category");
                    return <ProductCard key={product.id} product={product} locale={props.locale} categoryLabel={categoryLabel} categoryPath={category ? `/${props.locale}/products/${category.id}` : undefined} quantity={props.quantities[product.id] ?? 1} t={props.t} onQuantityChange={props.onQuantityChange} onAdd={props.onAdd} />;
                })}
            </FlareCollectionView>
        </section>
    );
}
